export function getWorkflowUniqKey(workflowId: number | null | undefined) {
  return ["taskDetails", workflowId];
}
